import PropTypes from 'prop-types';
import { createFragmentContainer, graphql } from 'react-relay/legacy';

import {
    REGULAR_MODULE_TYPE,
    BANNER_MODULE_TYPE,
    PROMO_MODULE_TYPE,
    BANNER_TILES_MODULE_TYPE,
} from '../../constants/contentModuleConstants';

import { SbRespContentModuleRegular } from '../SbRespContentModuleRegular/SbRespContentModuleRegular';
import { SbSharedContentModuleBanner } from '../SbSharedContentModuleBanner/SbSharedContentModuleBanner';
import { SbSharedContentModulePromo } from '../SbSharedContentModulePromo/SbSharedContentModulePromo';
import { SbSharedContentModuleBannerTiles } from '../SbSharedContentModuleBannerTiles/SbSharedContentModuleBannerTiles';

const SbRespContentModuleSelectorComponent = ({ itemSearch }) => {
    const { browseContentModule } = itemSearch;

    if (!browseContentModule) {
        return null;
    }

    switch (browseContentModule.moduleType) {
        case REGULAR_MODULE_TYPE:
            return <SbRespContentModuleRegular browseContentModule={browseContentModule} />;
        case BANNER_MODULE_TYPE:
            return (
                <SbSharedContentModuleBanner
                    browseContentModule={browseContentModule}
                    renderImage={({ src, imgClassName, alt }) => (
                        <img src={src} className={imgClassName} alt={alt} />
                    )}
                />
            );
        case PROMO_MODULE_TYPE:
            return (
                <SbSharedContentModulePromo
                    browseContentModule={browseContentModule}
                    renderImage={({ src, imgClassName, alt }) => (
                        <img src={src} className={imgClassName} alt={alt} />
                    )}
                />
            );
        case BANNER_TILES_MODULE_TYPE:
            return <SbSharedContentModuleBannerTiles browseContentModule={browseContentModule} />;
        default:
            return null;
    }
};

SbRespContentModuleSelectorComponent.propTypes = {
    itemSearch: PropTypes.object.isRequired,
};

export const SbRespContentModuleSelector = createFragmentContainer(
    SbRespContentModuleSelectorComponent,
    {
        itemSearch: graphql`
            fragment SbRespContentModuleSelector_itemSearch on ItemSearchQueryConnection {
                browseContentModule(contentModuleId: $contentModuleId) {
                    moduleType
                    ...SbRespContentModuleRegular_browseContentModule
                    ...SbSharedContentModuleBanner_browseContentModule
                    ...SbSharedContentModulePromo_browseContentModule
                    ...SbSharedContentModuleIconicDesign_browseContentModule
                    ...SbSharedContentModuleBannerTiles_browseContentModule
                }
            }
        `,
    }
);
